export const NAV_CONTEXT = Object.freeze({ GESTAO: 'gestao', CLIENTE: 'cliente' })

export default {
  context: NAV_CONTEXT.GESTAO,
}
